var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"post-preview-body"},[_c('p',{staticClass:"post-preview-body__content",domProps:{"innerHTML":_vm._s(_vm.trimHref)}})])}
var staticRenderFns = []

export { render, staticRenderFns }